import Vue, { ComponentOptions } from 'vue';
import App from './App.vue';
import Router, { Route, RouteConfig } from 'vue-router';
import '@/styles/common.less';
import '@/common';
import { toast } from '@mx/vix';
import { initTransPage } from '@/common/transPage';
import { bridge } from '@/common/bridge';

Vue.use(Router);

export default function init(
  routes: RouteConfig[],
  options?: ComponentOptions<any>
) {
  const router = new Router({
    routes
  });

  initTransPage(router);

  router.beforeEach((to: Route, from: Route, next: () => void) => {
    toast.show();
    next();
  });

  router.beforeResolve((to: Route, from: Route, next: () => void) => {
    toast.hide();
    next();
  });

  router.afterEach((to: Route, from: Route) => {
    if (to.meta.title) {
      bridge.setTitle(to.meta.title);
    }
  });

  Vue.config.productionTip = false;

  new Vue({
    ...options,
    router,
    mounted() {
      bridge.ehShow();
    },
    render: (h) => h(App)
  }).$mount('#app');
}
